import React from 'react';
export function Footer() {
  const navLinks = [{
    name: 'El Problema',
    href: '#el-problema'
  }, {
    name: 'El Sistema',
    href: '#el-sistema'
  }, {
    name: 'Sobre mí',
    href: '#sobre-mi'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Agendar',
    href: '#agendar'
  }];
  return <footer className="bg-[#050505] border-t-2 border-accent pt-16 pb-8" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-16" data-id="element-61">
          {/* Left Column */}
          <div data-id="element-62">
            <a href="#" className="flex flex-col mb-2" data-id="element-63">
              <span className="font-heading font-bold text-2xl text-white tracking-tight" data-id="element-64">
                Joaquín González Paredes
              </span>
              <span className="text-accent text-sm font-medium tracking-wider uppercase mt-1" data-id="element-65">
                Sistema de Demanda Sostenida
              </span>
            </a>
            <p className="text-gray-500 text-sm mt-4" data-id="element-66">
              Marketing Gastronómico para LATAM
            </p>
          </div>

          {/* Right Column */}
          <div className="flex flex-wrap gap-x-8 gap-y-4" data-id="element-67">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-400 hover:text-accent transition-colors duration-300 text-sm font-medium" data-id="element-68">
                {link.name}
              </a>)}
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center" data-id="element-69">
          <p className="text-gray-600 text-sm" data-id="element-70">
            © 2025 Joaquín González Paredes. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}